export default __webpack_public_path__ + "static/media/img-ovato-coin-stack-new.9eaca92d.jpg";